import {
  websocketConstants,
  workdeskTicketsConstants,
} from 'store/constants';
import { WorkdeskTickets } from 'store/models/workdesk-tickets/WorkdeskTickets';
import { assignTicketConstants } from 'store/constants';
import { manualSiConstants } from 'store/constants';
import { EachWorkdeskTicketI } from 'store/models/workdesk-tickets/each-workdesk-ticket.interface';
import HasLoadedHelper, {
  StoreHasLoadedI,
} from 'store/models/workdesk-tickets/HasLoadedHelper';
import { EachAssigneesRes } from 'store/models/Assignees';
import {
  AllInboxesStatusLatestUpdateDate,
  AllInboxesStatusLatestUpdateDateI,
} from 'store/models/InboxesStatusLatestUpdateDate';
import { IsJustChangeType } from 'store/models/workdesk-tickets/workdesk-tickets.interface';

const initialState: {
  assigneeIdToInfo: { [id: number]: EachAssigneesRes[] };
  ticketsMap: { [ticketId: number]: EachWorkdeskTicketI };
  hasLoaded: StoreHasLoadedI;
  assigningTicketIdMap: { [id: string]: boolean };
  isLoadingStatuses: { [status: string]: boolean };
  isWsLoadingStatuses: { [status: string]: boolean };
  loadingBodyHtmlsIds: string[];
  previewingBodyHtmlId: null | string;
  isPostingManualSiIdMap: { [id: string]: boolean };
  isJustChangedTicketIdMap: { [id: string]: IsJustChangeType };
  latestWithSearchTicketsCount?: number;
  statusChangedIds: string[];
  fromWsTicketIds: string[];

  allInboxesStatusLatestUpdateDate: AllInboxesStatusLatestUpdateDateI;
} = {
  assigneeIdToInfo: {},
  ticketsMap: {},
  assigningTicketIdMap: {},
  hasLoaded: {},
  isLoadingStatuses: {},
  isWsLoadingStatuses: {},
  loadingBodyHtmlsIds: [],
  previewingBodyHtmlId: null,
  isPostingManualSiIdMap: {},
  isJustChangedTicketIdMap: {},
  latestWithSearchTicketsCount: undefined,
  statusChangedIds: [],
  fromWsTicketIds: [], // used to keep track of what are from ws. it affects decision to fetch tickets or use cached

  allInboxesStatusLatestUpdateDate: AllInboxesStatusLatestUpdateDate.getDefault(),
};

export const workdeskTickets = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  const {
    ticketsMap,
    assigneeIdToInfo,
    hasLoaded,
    error,
    status,
    ids, // LOAD_BODY_HTMLS_REQUEST
    latestWithSearchTicketsCount,
  } = action.payload || {};

  switch (action.type) {
    case workdeskTicketsConstants.ADD_STATUS_CHANGED_IDS:
      if (!action.payload.statusChangedIds)
        throw Error(`payload.statusChangedIds is missing`);
      const combined = state.statusChangedIds.concat(
        action.payload.statusChangedIds,
      );
      return {
        ...state,
        statusChangedIds: Array.from(new Set(combined)),
      };
    case workdeskTicketsConstants.REMOVE_STATUS_CHANGED_IDS:
      if (!action.payload.statusChangedIds)
        throw Error(`payload.statusChangedIds is missing`);
      return {
        ...state,
        statusChangedIds: state.statusChangedIds.filter(
          (id) => !action.payload.statusChangedIds.includes(id),
        ),
      };
    case workdeskTicketsConstants.LOAD_TICKETS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoadingStatuses: {
          ...state.isLoadingStatuses,
          [status]: true,
        },
      };
    case workdeskTicketsConstants.WS_LOAD_TICKETS_REQUEST:
      return {
        ...state,
        isWsLoadingStatuses: {
          ...state.isWsLoadingStatuses,
          [status]: true,
        },
      };
    case websocketConstants.WS_DISCONNECTED:
      // NOTE: action.payload.socketId is sent for tracking
      return {
        ...state,
        isWsLoadingStatuses: {},
      };
    case workdeskTicketsConstants.LOAD_TICKETS_SUCCESS:
      if (status === undefined) {
        throw Error(`payload.status is missing`);
      }
      return {
        ...state,
        isLoading: false,
        isLoadingStatuses: {
          ...state.isLoadingStatuses,
          [status]: false,
        },
        latestWithSearchTicketsCount: latestWithSearchTicketsCount,
      };
    case workdeskTicketsConstants.WS_LOAD_TICKETS_SUCCESS:
      if (!action.payload.ticketIds) {
        throw Error(`payload.ticketIds is missing`);
      }

      const fromWsTicketIds = action.payload.ticketIds.length
        ? WorkdeskTickets.deduplicateIds(
            state.fromWsTicketIds.concat(action.payload.ticketIds),
          )
        : state.fromWsTicketIds; // used to keep track of what are from ws. it affects decision to fetch tickets or use cached
      console.debug(
        `bottom! ws load ticket success: `,
        fromWsTicketIds,
      );
      return {
        ...state,
        isLoading: false,
        isWsLoadingStatuses: {},
        fromWsTicketIds,
      };
    case workdeskTicketsConstants.REMOVE_IDS_FROM_WS_TICKET_IDS:
      if (!action.payload.ids) {
        throw Error(`payload.ids is missing`);
      }
      return {
        ...state,
        fromWsTicketIds: state.fromWsTicketIds.filter(
          (id) => !action.payload.ids.includes(id),
        ),
      };
    case workdeskTicketsConstants.UPDATE_TICKETS:
      if (!assigneeIdToInfo) {
        console.info(
          `assigneeIdToInfo is undefined or null. ${assigneeIdToInfo}`,
        );
      }
      return {
        ...state,
        ticketsMap,
        assigneeIdToInfo:
          assigneeIdToInfo || state.assigneeIdToInfo || {},
        hasLoaded: hasLoaded || state.hasLoaded,
      };
    case workdeskTicketsConstants.REMOVE_TICKETS_IN_HASLOADED_AT_PARAMS:
      if (!action.payload.params) {
        throw Error(`payload.params is missing`);
      }
      return {
        ...state,
        hasLoaded: new HasLoadedHelper(
          state.hasLoaded,
          state.ticketsMap,
        ).removeTicketsAtParams(action.payload.params),
      };
    case workdeskTicketsConstants.LOAD_TICKETS_ERROR:
      return {
        ...state,
        isLoading: false,
        isLoadingStatuses: {
          ...state.isLoadingStatuses,
          [status]: false,
        },
        error,
      };

    // -----------------------------
    case manualSiConstants.MANY_MANUAL_SI_POST:
      // ticketIdSiList
      if (!action.payload.ticketIdSiList)
        throw Error(`ticketIdSiList is missing`);
      if (!Array.isArray(action.payload.ticketIdSiList))
        throw Error(`ticketIdSiList must be an array`);
      return {
        ...state,
        isPostingManualSiIdMap: action.payload.ticketIdSiList.reduce(
          (acc, ticket) => ({ ...acc, [ticket.id]: true }),
          {},
        ),
      };
    case manualSiConstants.MANY_MANUAL_SI_SUCCESS:
      // ticketIds
      if (!action.payload.ticketIds)
        throw Error(`ticketIds is missing`);
      if (!Array.isArray(action.payload.ticketIds))
        throw Error(`ticketIds must be an array`);
      return {
        ...state,
        isPostingManualSiIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.isPostingManualSiIdMap,
        ),
        isJustChangedTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: 'NEW' }),
          state.isJustChangedTicketIdMap,
        ),
      };
    case manualSiConstants.MANY_MANUAL_SI_ERROR:
      // ticketIds, error
      // ticketIds
      if (!action.payload.ticketIds)
        throw Error(`ticketIds is missing`);
      if (!Array.isArray(action.payload.ticketIds))
        throw Error(`ticketIds must be an array`);
      return {
        ...state,
        isPostingManualSiIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.isPostingManualSiIdMap,
        ),
        error,
      };
    // ------------------------------

    case assignTicketConstants.ASSIGNTICKET_POST:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: true }),
          state.assigningTicketIdMap,
        ),
      };
    case assignTicketConstants.ASSIGNTICKET_SUCCESS:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.assigningTicketIdMap,
        ),
        isJustChangedTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: 'NEW' }),
          state.isJustChangedTicketIdMap,
        ),
      };
    case workdeskTicketsConstants.UPDATE_TICKET:
      if (!ticketsMap) throw Error(`ticketsMap cannot be undefined`);
      if (!hasLoaded) throw Error(`hasLoaded cannot be undefined`);
      return {
        ...state,
        assigneeIdToInfo: assigneeIdToInfo || state.assigneeIdToInfo,
        ticketsMap,
        hasLoaded,
      };
    case assignTicketConstants.ASSIGNTICKET_ERROR:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.assigningTicketIdMap,
        ),
        error,
      };
    // ----------------------------------------------------------------
    case assignTicketConstants.UNASSIGN_TICKET_POST:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: true }),
          state.assigningTicketIdMap,
        ),
      };
    case assignTicketConstants.UNASSIGN_TICKET_SUCCESS:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.assigningTicketIdMap,
        ),
        isJustChangedTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: 'NEW' }),
          state.isJustChangedTicketIdMap,
        ),
      };
    case assignTicketConstants.UNASSIGN_TICKET_ERROR:
      return {
        ...state,
        assigningTicketIdMap: action.payload.ticketIds.reduce(
          (acc, id) => ({ ...acc, [id]: false }),
          state.assigningTicketIdMap,
        ),
        error,
      };
    case workdeskTicketsConstants.CLEAR_JUST_CHANGE_TICKET_ID:
      return {
        ...state,
        isJustChangedTicketIdMap: {},
      };
    case workdeskTicketsConstants.MARK_IS_JUST_CHANGED:
      if (!action.payload.ids) throw Error(`ids is missing`);
      if (!action.payload.value) throw Error(`value is missing`);
      return {
        ...state,
        isJustChangedTicketIdMap: action.payload.ids.reduce(
          (acc, id) => ({ ...acc, [id]: action.payload.value }),
          state.isJustChangedTicketIdMap,
        ),
      };
    case workdeskTicketsConstants.LOAD_BODY_HTMLS_REQUEST:
      if (!ids) throw Error(`ids cannot be undefined`);
      return {
        ...state,
        loadingBodyHtmlsIds: ids,
      };
    case workdeskTicketsConstants.LOAD_BODY_HTMLS_REQUEST_SUCCESS:
      if (!ticketsMap) throw Error(`ticketsMap cannot be undefined`);
      return {
        ...state,
        loadingBodyHtmlsIds: [],
        ticketsMap,
      };
    case workdeskTicketsConstants.LOAD_BODY_HTMLS_REQUEST_ERROR:
      return {
        ...state,
        loadingBodyHtmlsIds: [],
        error,
      };
    case workdeskTicketsConstants.PREVIEW_BODY_HTML_ID:
      if (!action.payload.id) throw Error(`missing id`);
      return {
        ...state,
        previewingBodyHtmlId: action.payload.id,
      };
    case workdeskTicketsConstants.CLOSE_PREVIEW_BODY_HTML_ID:
      return {
        ...state,
        previewingBodyHtmlId: null,
      };
    case workdeskTicketsConstants.UPDATE_ALL_INBOXES_STATUS_LATEST_UPDATE_DATE:
      if (!action.payload.allInboxesStatusLatestUpdateDate)
        throw Error(
          `missing payload.allInboxesStatusLatestUpdateDate`,
        );
      return {
        ...state,
        allInboxesStatusLatestUpdateDate:
          action.payload.allInboxesStatusLatestUpdateDate,
      };
    case workdeskTicketsConstants.MERGE_TICKETS_TO_TICKETS_MAP:
      if (!action.payload.tickets) {
        throw Error(`payload.tickets is missing`);
      }
      const merged = new WorkdeskTickets(
        state.ticketsMap,
      ).mergeTickets(action.payload.tickets);
      return {
        ...state,
        ticketsMap: merged.ticketsMap,
      };
    case workdeskTicketsConstants.RESET:
      return initialState;
    default:
      return state;
  }
};
